"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsletterCloseButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.NewsletterCloseButton = styled_components_1.default.button `
    position: absolute;
    top: 5px;
    right: 10px;
    cursor: pointer;
    color: #000;
    font-weight: bold;
    opacity: 0.5;
    transition: opacity 0.3s ${(p) => p.theme.easing};
    &::before {
        content: '\\2A2F';
        font-size: 42px;
    }
    &:hover {
        opacity: 1;
    }
`;
//# sourceMappingURL=NewsletterCloseBtn.atom.js.map